$(function () {
	// class名（"img_lazy_aspectratio）で対象のimg要素を取得
	const imgs = document.getElementsByClassName('img_lazy_aspectratio');

	for (const img of imgs) {
		// img要素のdata-src属性の値（オリジナル画像パず）を取得
		const src = img.getAttribute('data-src');

		onloadImage(src).then(function (res) {
			// 読み込みが完了した（画像が設定された）Imageオブジェクトを受け取って処理
			// imgタグの各属性に値を設定する
			img.setAttribute('width', res.width);   // 幅
			img.setAttribute('height', res.height); // 高さ
			img.setAttribute('data-aspectratio', res.width + '/' + res.height); // アスペクト比
		});
	}
});

// 画像読み込み時の処理
function onloadImage(src) {
	return new Promise(function (resolve, reject) {
		const image = new Image();
		// 読み込む画像を設定（関数の引数で取得した画像パスを代入）
		image.src = src;

		image.onload = function () {
			// 読み込み成功時にthenの処理へ
			resolve(image);
		}
	});
}
